import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__ from "@radix-ui/react-checkbox";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__ from "@radix-ui/react-icons";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
const Checkbox = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ label: CustomLabel, id, position = 'center', ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: `ptw-flex ${'center' === position ? 'ptw-items-center' : 'ptw-items-start'}`,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__.Root, {
                className: "ptw-flex ptw-h-[24px] ptw-w-[24px] ptw-min-w-[24px] ptw-items-center ptw-justify-center ptw-rounded-[2px] ptw-border-medium ptw-border-solid ptw-border-secondary-base ptw-bg-primary-text aria-checked:ptw-bg-secondary-base data-[error=true]:ptw-outline-error-base",
                ...props,
                id: id,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__.Indicator, {
                    className: "ptw-pt-2 ptw-text-body-lg ptw-text-primary-text",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.CheckIcon, {
                        width: 20,
                        height: 20
                    })
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Label, {
                className: "ptw-text-white ptw-pl-[15px] ptw-text-[15px] ptw-leading-none",
                htmlFor: id,
                children: 'string' == typeof CustomLabel ? CustomLabel : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomLabel, {})
            })
        ]
    }));
export { Checkbox };
